module.exports = __webpack_public_path__ + "static/media/Icon-cancel.f12f9a6f.svg";